// extracted by mini-css-extract-plugin
export default {"paginadoH":"Paginado_paginadoH__a9FG8","containerPaginado":"Paginado_containerPaginado__WpZTK","numPag":"Paginado_numPag__g2WH2","btnCambio":"Paginado_btnCambio__DuZ61"};